// extracted by mini-css-extract-plugin
export var arrows = "_72-6";
export var decrementer = "_72-a";
export var disabled = "_72-4";
export var error = "_72-1";
export var hiddenText = "_72-b";
export var incrementer = "_72-9";
export var input = "_72-8";
export var inputWrapper = "_72-0";
export var leadingIcon = "_72-c";
export var readonly = "_72-3";
export var regular = "_72-7";
export var small = "_72-5";
export var warning = "_72-2";